import TransitionService from 'edge/platform/widgets/accordion/transition/TransitionService';

export default angular.module('edge.platform.widgets.ui.bootstrap.transition', []).factory('$gwPlTransition', TransitionService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/accordion/transition/module.js
// module id = 351
// module chunks = 0